import React from 'react'
import { useForm } from '../../../providers'
import { FormControl, FormLabel, Box } from '@material-ui/core'
import { Controls } from '../../../components/FormControls/Controls'
import { makeStyles } from '@material-ui/core'
import { capitalize } from '../../../utils'
import { typesOfRequirement } from '../../../data/typesOfRequirement'

const useStyles = makeStyles((theme) => ({
    numOfRequirementContainer: {
        display: 'block',
        '@media (min-width:380px)': {
            display: 'flex',
            justifyContent: 'space-between',
            gap: theme.spacing(2),
        },
    },
}))

const NumberOfRequirementsInput = ({ type }) => {
    const { formState, error, handleRequirements } = useForm()

    return (
        <Controls.Input
            variant="outlined"
            label={capitalize(type)}
            required
            fullWidth
            type="number"
            inputProps={{
                min: '0',
            }}
            name="numOfRequirements"
            onChange={(e) => handleRequirements(type, e.target.value)}
            value={formState.numOfRequirements[type]}
            error={error?.numOfRequirements ? true : false}
            helperText={error?.numOfRequirements ? 'Required' : ''}
        />
    )
}

export const NumberOfRequirements = () => {
    const classes = useStyles()

    return (
        <FormControl>
            <FormLabel>{'No of requirements'}</FormLabel>
            <Box className={classes.numOfRequirementContainer}>
                {typesOfRequirement.map((requirement) => (
                    <NumberOfRequirementsInput key={requirement.id} type={requirement.title} />
                ))}
            </Box>
        </FormControl>
    )
}
